module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_d/aoj_d-3-2f29d2b105e37b000a6bcb0325f28f62.jpg";